module.exports = __webpack_public_path__ + "static/media/b-sci-major-13_LR.45dc15a5.jpg";